import { render, staticRenderFns } from "./KaiJiang.vue?vue&type=template&id=ec20bd22&scoped=true"
import script from "./KaiJiang.vue?vue&type=script&lang=js"
export * from "./KaiJiang.vue?vue&type=script&lang=js"
import style0 from "./KaiJiang.vue?vue&type=style&index=0&id=ec20bd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec20bd22",
  null
  
)

export default component.exports